<template>
  <div>
    <el-container>
        <el-col :span="2" :offset="1">
          <el-upload
            class="upload-demo"
            action="https://assert.hyhdit.com/apiYang/propertySort/importExcelBigData"
            :on-change="handleChange"
            :on-success="handleSuccess"
            :on-progress="handleProgress"
            :headers="token">
            <el-button  type="danger">点击上传文件批量导入类别信息</el-button>
          </el-upload>

        </el-col>
        <el-col :span="2" :offset="1">
          <el-button type="primary" @click="detele()">删除</el-button>
        </el-col>
    </el-container>
    <el-container>
      <el-table
          @select="select"
          @select-all="selectAll"
          @selection-change="selectionChange"
          ref="multipleTable"


          :data="tableData"
          style="width: 100%;margin-bottom: 20px;"
          row-key="sortId"
          border
          default-expand-all
          :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
          <el-table-column
                type="selection"
                width="55">
              </el-table-column>

          <el-table-column
            prop="sortName"
            label="资产类别名称"
            sortable
            width="180">
          </el-table-column>
          <el-table-column
            prop="code"
            label="国标编号"
            sortable
            width="180">
          </el-table-column>
          <el-table-column
            prop="unitName"
            label="单位名称">
          </el-table-column>
          <el-table-column
            prop="createDate"
            label="创建时间">
          </el-table-column>
        </el-table>
    </el-container>
  </div>
</template>

<script>
  import axios from 'axios'
  import Cookies from "js-cookie";
  import qs from "qs"
  export default {
     name: 'Category',
     data () {
       const tableData = [{
               code:'',
               del:"",
               createDate:'',
               mgrName:'',
               sortName:'',
               sortId:'',
               unitId:'',
               unitName:'',
               children: [{
                 code:'',
                 del:"",
                 createDate:'',
                 mgrName:'',
                 sortName:'',
                 sortId:'',
                 unitId:'',
                 unitName:'',
                 children: [{
                   code:'',
                   del:"",
                   createDate:'',
                   mgrName:'',
                   sortName:'',
                   sortId:'',
                   unitId:'',
                   unitName:'',
                 }]
               }]
             }];
       return {
         token:{
           Authorization:Cookies.get("Authorization")
         },
           tableData: JSON.parse(JSON.stringify(tableData)),
        };
     },
			created:function() {
       this.showData();
     },
     watch: {
           filterText(val) {
             this.$refs.tree.filter(val);
           }
         },
     methods: {

       setChildren(children, type) {
             // 编辑多个子层级
             children.map(j => {
               this.toggleSelection(j, type)
               if (j.children) {
                 this.setChildren(j.children, type)
               }
             })
           },
           // 选中父节点时，子节点一起选中取消
           select(selection, row) {
             const hasSelect = selection.some(el => {
               return row.sortId === el.sortId
             })
             if (hasSelect) {
               if (row.children) {
                 // 解决子组件没有被勾选到
                 this.setChildren(row.children, true)
               }
             } else {
               if (row.children) {
                 this.setChildren(row.children, false)
               }
             }
           },
           toggleSelection(row, select) {
             if (row) {
               this.$nextTick(() => {
                 this.$refs.multipleTable &&
                   this.$refs.multipleTable.toggleRowSelection(row, select)
               })
             }
           },
           // 选择全部
           selectAll(selection) {
             // tabledata第一层只要有在selection里面就是全选
             const isSelect = selection.some(el => {
               const tableDataIds = this.tableData.map(j => j.sortId)
               return tableDataIds.includes(el.sortId)
             })
             // tableDate第一层只要有不在selection里面就是全不选
             const isCancel = !this.tableData.every(el => {
               const selectIds = selection.map(j => j.sortId)
               return selectIds.includes(el.sortId)
             })
             if (isSelect) {
               selection.map(el => {
                 if (el.children) {
                   // 解决子组件没有被勾选到
                   this.setChildren(el.children, true)
                 }
               })
             }
             if (isCancel) {
               this.tableData.map(el => {
                 if (el.children) {
                   // 解决子组件没有被勾选到
                   this.setChildren(el.children, false)
                 }
               })
             }
           },
           selectionChange(val) {
             this.multipleSelection = val;
           },






        detele(){
          var authorization = Cookies.get("Authorization");
          var deleteData = []
          for(let i of this.multipleSelection){
            deleteData.push(i.sortId)
          }
          this.axios({
              method: 'POST',
              url: '/propertySort/delete',
              params:{
                ids:deleteData
              },
              paramsSerializer:params =>{
                return qs.stringify(params,{indices:false})
              },
              header:{
               'Authorization':authorization,
              	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
              	}
            }).then((resp)=>{
                if(resp.data.code == 200){
                	this.open4('删除成功')
                }else{
                	this.open4("删除失败")
                }
                this.showData()
            })
        },
		handleProgress() {
			this.$notify({
			  title: '上传中......',
			  message: '上传中，请稍等.....',
			  type: 'warning',
			  duration: 3000
			});
		},
		open4(val) {
					this.$notify({
						message: val,
						type: 'success',
						duration: 3000
						});
		      },
        open2(val) {
                this.$notify({
                  message: val,
                  type: 'success',
                  duration: 3000
                });
              },
		open3(val) {
		        this.$notify({
		          message: val,
		          type: 'danger',
		          duration: 3000
		        });
		      },
			handleSuccess(res){
			  if(res.code==200){
			  	this.open2(res.message)
				this.showData()
			  }else{
			  	this.open3(res.message)
			  }
			},

      showData(){
       var authorization = Cookies.get("Authorization");
        this.axios({
            method: 'GET',
            url: '/propertySort/showPropertySortDetail',
            header:{
             'Authorization':authorization,
             'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
            	}
          }).then((resp)=>{
           this.tableData=resp.data.data;
          })
      },
     }
   }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Munber/Category.vue